import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { COMPANY, NAV_LINKS } from "../lib/constants";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#0F213A] shadow-lg"
          : "bg-[#0F213A]/95 backdrop-blur"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a
            href="#top"
            data-testid="logo-link"
            className="flex items-baseline gap-2 group"
          >
            <span className="text-white text-xl md:text-2xl font-black tracking-tight">
              JL
            </span>
            <span className="text-white/70 text-sm md:text-base font-medium tracking-[0.2em] uppercase">
              Service
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-10">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="text-white/80 hover:text-white text-sm font-semibold uppercase tracking-[0.18em] transition-colors relative after:content-[''] after:absolute after:-bottom-2 after:left-0 after:w-0 after:h-[2px] after:bg-white hover:after:w-full after:transition-all after:duration-300"
              >
                {l.label}
              </a>
            ))}
          </nav>

          {/* CTA */}
          <a
            href={`tel:${COMPANY.phoneRaw}`}
            data-testid="header-call-btn"
            className="hidden md:inline-flex items-center gap-2 bg-white text-[#0F213A] px-5 py-3 text-sm font-bold uppercase tracking-[0.15em] btn-lift"
          >
            <Phone size={16} strokeWidth={2.5} />
            Ring nu
          </a>

          {/* Mobile toggle */}
          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
            className="md:hidden text-white p-2"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div
            data-testid="mobile-menu"
            className="md:hidden pb-6 pt-2 border-t border-white/10"
          >
            <nav className="flex flex-col gap-1">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                  className="text-white/90 text-base font-semibold uppercase tracking-[0.15em] py-3 border-b border-white/5"
                >
                  {l.label}
                </a>
              ))}
              <a
                href={`tel:${COMPANY.phoneRaw}`}
                data-testid="mobile-call-btn"
                className="mt-4 inline-flex items-center justify-center gap-2 bg-white text-[#0F213A] px-6 py-4 text-sm font-bold uppercase tracking-[0.15em]"
              >
                <Phone size={18} strokeWidth={2.5} />
                Ring {COMPANY.phone}
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
